import React from 'react';
import { RichTextRenderer } from '../components/RichTextRenderer';
import { Article } from '../types';

interface ArticlePageProps {
  article: Article;
  onBackClick: () => void;
}

export const ArticlePage: React.FC<ArticlePageProps> = ({ article, onBackClick }) => (
  <article className="max-w-4xl mx-auto">
    <button
      onClick={onBackClick}
      className="text-yellow-500 hover:text-yellow-600 mb-12 flex items-center gap-3 font-headline font-black text-xl uppercase tracking-wider transition-all hover:gap-4"
    >
      ← Takaisin
    </button>

    {article.featuredImage && (
      <img
        src={article.featuredImage}
        alt={article.title}
        className="w-full aspect-video object-cover mb-12 shadow-2xl rounded-lg"
      />
    )}

    <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-display font-black mb-8 text-gray-900 leading-none uppercase tracking-tighter">
      {article.title}
    </h1>

    <div className="text-gray-600 mb-12 text-base font-headline font-bold uppercase tracking-widest">
      {new Date(article.publishedDate).toLocaleDateString('fi-FI', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
    </div>

    <div className="prose prose-xl max-w-none">
      <p className="text-2xl md:text-3xl text-gray-800 mb-10 leading-relaxed font-body font-medium">
        {article.excerpt}
      </p>
      <div className="text-gray-800 text-lg leading-loose font-body">
        {typeof article.content === 'string'
          ? article.content.split('\n').map((line, i) => (
            <p key={i} className="mb-4">{line}</p>
          ))
          : <RichTextRenderer document={article.content} assets={article.assets} />
        }
      </div>
    </div>
  </article>
);